import {useState, useEffect} from 'react';
import {db} from '../firebase/firebaseConfig';
import {useAuth} from '../context/AuthContext';
import { collection, onSnapshot, query, where } from 'firebase/firestore';

const useConfig = () => {
	const [config, setConfig] = useState([]);
	const {usuario} = useAuth();

	useEffect(() => {
		if(usuario){
			const queryDB = query(
				collection(db, 'config'),				
				where('userId', '==', usuario.uid)
			);

			const unsuscribe = onSnapshot(queryDB, (snapshot) => {
				setConfig(snapshot.docs.map((documento) => {
					return {...documento.data(), id: documento.id}
				}))
			}, (error) => {return error});

			return unsuscribe;
		}
	}, [usuario]);

	return config;
}
 
export default useConfig;